/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Binding_Workflows_DetailInputs */

const en_marketing_binding_workflows_detail = /** @type {(inputs: Marketing_Binding_Workflows_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durable multi-step processes that survive restarts.`)
};

const es_marketing_binding_workflows_detail = /** @type {(inputs: Marketing_Binding_Workflows_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesos duraderos de varios pasos que sobreviven a los reinicios.`)
};

const fr_marketing_binding_workflows_detail = /** @type {(inputs: Marketing_Binding_Workflows_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processus durables en plusieurs étapes qui survivent aux redémarrages.`)
};

/**
* | output |
* | --- |
* | "Durable multi-step processes that survive restarts." |
*
* @param {Marketing_Binding_Workflows_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_binding_workflows_detail = /** @type {((inputs?: Marketing_Binding_Workflows_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Binding_Workflows_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_binding_workflows_detail(inputs)
	if (locale === "es") return es_marketing_binding_workflows_detail(inputs)
	return fr_marketing_binding_workflows_detail(inputs)
});